import React from 'react';
import { LinearProgress } from '@mui/material';

import './_loader.scss';

const LoadPage = () => (
  <section className="loader">
    <LinearProgress />
  </section>
);

export default LoadPage;
